var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup18(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.46 13.7299C12.0119 13.7299 13.27 12.4718 13.27 10.9199C13.27 9.36794 12.0119 8.10986 10.46 8.10986C8.9081 8.10986 7.65002 9.36794 7.65002 10.9199C7.65002 12.4718 8.9081 13.7299 10.46 13.7299Z",
    stroke: "#50535F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.65 20.1998C15.65 17.8698 13.33 15.9697 10.46 15.9697C7.59002 15.9697 5.27002 17.8598 5.27002 20.1998",
    stroke: "#50535F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.5C20 17.75 15.75 22 10.5 22C5.25 22 1 17.75 1 12.5C1 7.25 5.25 3 10.5 3C11.81 3 13.06 3.25999 14.2 3.73999C14.07 4.13999 14 4.56 14 5C14 5.75 14.21 6.46 14.58 7.06C14.78 7.4 15.04 7.70997 15.34 7.96997C16.04 8.60997 16.97 9 18 9C18.44 9 18.86 8.92998 19.25 8.78998C19.73 9.92998 20 11.19 20 12.5Z",
    stroke: "#50535F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5C22 5.32 21.96 5.62999 21.88 5.92999C21.79 6.32999 21.63 6.72 21.42 7.06C20.94 7.87 20.17 8.49998 19.25 8.78998C18.86 8.92998 18.44 9 18 9C16.97 9 16.04 8.60997 15.34 7.96997C15.04 7.70997 14.78 7.4 14.58 7.06C14.21 6.46 14 5.75 14 5C14 4.56 14.07 4.13999 14.2 3.73999C14.39 3.15999 14.71 2.64002 15.13 2.21002C15.86 1.46002 16.88 1 18 1C19.18 1 20.25 1.51002 20.97 2.33002C21.61 3.04002 22 3.98 22 5Z",
    stroke: "#50535F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.49 4.97998H16.51",
    stroke: "#50535F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3.52002V6.51001",
    stroke: "#50535F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup18);
export default __webpack_public_path__ + "static/media/Group 18.b071f68d.svg";
export { ForwardRef as ReactComponent };